module.exports = __webpack_public_path__ + "img/home-right-bg.552399b7.png";